// Shared voice + wake-word configuration for OMY

export const VOICES = [
  { id: "shimmer", label: "Voix douce", desc: "Calme, posée et rassurante" },
  { id: "coral", label: "Chaleureuse", desc: "Amicale et naturelle" },
  { id: "nova", label: "Dynamique", desc: "Énergique et vive" },
  { id: "onyx", label: "Masculine", desc: "Grave et posée" },
];

export const VOICE_SAMPLE =
  "Bonjour, je suis OMY. Je retiens tout pour vous : garanties, entretiens, documents. Vous n'avez plus rien à mémoriser.";

export const DEFAULT_WAKE = "hey omy";

export const SENSITIVITIES = [
  { id: "strict", label: "Stricte", desc: "OMY ne se déclenche que sur la phrase exacte" },
  { id: "normal", label: "Normale", desc: "Le mot d'appel suffit, avec ou sans « hey »" },
  { id: "loose", label: "Souple", desc: "Se déclenche facilement (plus de faux positifs)" },
];

// --- Voice preference ---
export const getVoicePref = () => localStorage.getItem("omy_voice") || "shimmer";
export const setVoicePref = (v) => localStorage.setItem("omy_voice", v);

// --- Wake configuration ---
export const getWakeWord = () => (localStorage.getItem("omy_wake_word") || DEFAULT_WAKE).trim();
export const setWakeWord = (w) => localStorage.setItem("omy_wake_word", (w || "").trim() || DEFAULT_WAKE);
export const getWakeSensitivity = () => localStorage.getItem("omy_wake_sens") || "normal";
export const setWakeSensitivity = (s) => localStorage.setItem("omy_wake_sens", s);
export const getWakeEnabled = () => localStorage.getItem("omy_wake") === "1";
export const setWakeEnabled = (v) => localStorage.setItem("omy_wake", v ? "1" : "0");

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const GREET = "(?:hey|h[ée]|ho|ok|hi|allo|coucou|hello)";

// Builds a matcher function (transcript) => boolean using the user's wake word + sensitivity.
export function buildWakeMatcher() {
  const word = getWakeWord().toLowerCase();
  const sens = getWakeSensitivity();
  const tokens = word.split(/\s+/).filter(Boolean);
  const name = tokens[tokens.length - 1] || "omy";
  const isOmy = /^om/.test(name);
  const namePat = isOmy ? "om(?:y|i|mi|ie|mie|mmy)" : esc(name);

  let pattern;
  if (sens === "strict") {
    pattern = "\\b" + tokens.map(esc).join("\\s+") + "\\b";
  } else if (sens === "loose") {
    pattern = isOmy ? "om(?:y|i|mi|ie|mie|mmy|m)?" : esc(name);
  } else {
    pattern = GREET + "?\\s*" + namePat;
  }
  let re;
  try { re = new RegExp(pattern, "i"); } catch (e) { re = new RegExp(esc(word), "i"); }
  return (t) => re.test((t || "").toLowerCase());
}
